module.exports = __webpack_public_path__ + "img/other_bell.a656c40a.png";